<template>
  <div>
      <NavigationMenu />

      <header class="bg-gradient-to-r from-green-700 to-green-600 shadow-lg">
        <div class="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
          <div class="flex items-center justify-center gap-3">
            <div class="flex items-center justify-center w-12 h-12 rounded-xl bg-white bg-opacity-20 backdrop-blur-sm">
              <i class="fas fa-trophy text-2xl text-white"></i>
            </div>
            <div class="text-center sm:text-left">
              <h1 class="text-3xl font-bold text-white">
                Bolão do Brasileiro
              </h1>
              <p class="hidden sm:block text-green-100 text-sm mt-0.5">
                Faça seus palpites para a rodada
              </p>
            </div>
          </div>
        </div>
      </header>

      <div class="container mx-auto lg:flex mt-4 justify-between px-2 sm:p-0 sm:mt-4">
          <NavigationBetting />
          
          <div class="w-full sm:w-8/12 lg:w-9/12 mx-auto mr-0">
            <SaveBettingForm :userData=userData :roundId=roundId />
          </div>
      </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import jwt_decode from 'jwt-decode';
import NavigationMenu from '@/components/NavigationMenu';
import NavigationBetting from '@/components/NavigationBetting';
import SaveBettingForm from '@/components/SaveBettingForm';

export default {
  name: 'SaveBetting',
  components: {
    NavigationMenu,
    SaveBettingForm,
    NavigationBetting
  },
  computed: {
    ...mapGetters('user', {
      userProfile: 'userProfile',
    })
  },
  created() {
    let token = localStorage.getItem('token');
    if (token !== null) {
     try {
        let payload = jwt_decode(token);
        this.userData = payload;
      } catch (err) { console.log(err)}
    }
    this.roundId = this.$route.params.roundId;
  },
  data() {
    return {
      userData: null
    }
  }
}
</script>